module.exports = __webpack_public_path__ + "img/Linguetta_BASE_DX.da73ca55.png";